// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4d2cbea2","455":"486ec421","977":"5aeccadd"}[chunkId] + ".chunk.js";
};